import { ComponentRef, Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { LoadingSpinnerComponent } from '../_components/loading-spinner/loading-spinner.component';

@Directive({
  selector: '[appLoading]',
  standalone: true
})
export class AppLoadingDirective {
  private loadingComponentRef: ComponentRef<LoadingSpinnerComponent> | null = null;

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
  ) {}

  @Input() set appLoading(loading: boolean | null) {
    if (loading) {
      this.viewContainer.clear();
      this.loadingComponentRef = this.viewContainer.createComponent(LoadingSpinnerComponent);
    } else {
      if (this.loadingComponentRef) {
        this.loadingComponentRef.destroy();
        this.loadingComponentRef = null;
      }
      this.viewContainer.clear();
      this.viewContainer.createEmbeddedView(this.templateRef);
    }
  }
}
